// extracted by mini-css-extract-plugin
module.exports = {"summaryGrid":"Dashboard_summaryGrid__1IVrC","commentedFilter":"Dashboard_commentedFilter__r0khd"};